import moment from "moment";
import * as XLSX from "xlsx";

const HelperService = {
  addMinutes(date: any, minutes: number) {
    if (date && minutes) {
      let data = moment(date).add(minutes, "minutes");
      return data;
    } else {
      return new Date();
    }
  },

  addYear(date: any, year: number) {
    if (date && year) {
      let data = moment(date).add(year, "years");
      return data;
    } else {
      return new Date();
    }
  },

  removeYear(date: any, year: number) {
    if (date && year) {
      let data = moment(date).subtract(year, "years");
      return data;
    } else {
      return new Date();
    }
  },

  generateOTP(digit?: number) {
    var digits = '0123456789';
    let OTP = '';
    if (digit && digit > 0) {
      for (let i = 0; i < digit; i++) {
        OTP += digits[Math.floor(Math.random() * 10)];
      }
      return OTP;
    }
    for (let i = 0; i < 4; i++) {
      OTP += digits[Math.floor(Math.random() * 10)];
    }
    return OTP;
  },

  allowOnlyNumericValue(e: any) {
    var numbers = /^[0-9]$/;
    // Allow enter
    if (e.keyCode === 13) {
      return true;
    }
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 11) {
      e.preventDefault();
      return false;
    }
  },

  allowOnlyNumericValueUpto1(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 0) {
      e.preventDefault();
      return false;
    }
  },

  allowOnlyNumericValueUpto2(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 1) {
      e.preventDefault();
      return false;
    }
  },

  allowOnlyNumericValueUpto3(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 2) {
      e.preventDefault();
      return false;
    }
  },

  allowOnlyNumericValueUpto4(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 3) {
      e.preventDefault();
      return false;
    }
  },

  maxNumber(e: any, maxNumber: number) {
    if (maxNumber && e.currentTarget.value.length > maxNumber) {
      e.preventDefault();
      return false;
    }
  },

  contactFormatter: function (e: any) {
    if (e.currentTarget.value) {
      e.currentTarget.value = this.getFormattedContact(
        e.currentTarget.value ? e.currentTarget.value.replaceAll("-", "") : ""
      );
    }
  },

  allowNewDecimalValue(e: any) {
    let keyCode = e.keyCode ? e.keyCode : e.which;
    if (
      (keyCode < 48 || keyCode > 57) &&
      (keyCode != 46 || e.target.value.indexOf(".") != -1)
    ) {
      e.preventDefault();
      return false;
    }
    if (
      e.target.value != null &&
      e.target.value.indexOf(".") > -1 &&
      e.target.value.split(".")[1].length > 1 &&
      (e.target.selectionStart == e.target.value.length ||
        e.target.selectionStart == e.target.value.length - 1 ||
        e.target.selectionStart == e.target.value.length - 2)
    ) {
      e.preventDefault();
      return false;
    }
  },

  allowFourDecimalValue(e: any) {
    let keyCode = e.keyCode ? e.keyCode : e.which;

    if (
      (keyCode < 48 || keyCode > 57) &&
      (keyCode != 46 || e.target.value.indexOf(".") != -1)
    ) {
      e.preventDefault();
      return false;
    }

    if (
      e.target.value != null &&
      e.target.value.indexOf(".") > -1 &&
      e.target.value.split(".")[1].length > 1 &&
      (e.target.selectionStart == e.target.value.length ||
        e.target.selectionStart == e.target.value.length - 1 ||
        e.target.selectionStart == e.target.value.length - 2)
    ) {
      e.preventDefault();
      return false;
    }
    if (e.target.value > 99.99999) {
      // e.preventDefault();
      e.currentTarget.value = 99.9999;
    }
  },

  checkValue(e: any) {
    if (e.target.value > 99.99999) {
      e.currentTarget.value = 99.99;
    }
  },

  formateDecimal(value: any) {
    return value ? parseFloat(value).toFixed(2) : "";
  },
  removeDecimal(value: any) {
    return value ? Math.floor(value) : 0;
  },
  formateUptoTwoDecimal(e: any) {
    if (e && e.target) {
      e.currentTarget.value = this.formateDecimal(e.target.value);
    }
  },

  isValidEmail(email: string) {
    return email
      ? /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
      : true;
  },

  getFormattedContact: function (e: any) {
    if (e) {
      const match = e.toString().replace(/\D+/g, "");
      const part1 = match.length > 2 ? `${match.substring(0, 3)}` : match;
      const part2 = match.length > 3 ? `-${match.substring(3, 6)}` : "";
      const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : "";
      var x = part1 + "" + part2 + "" + part3;
      return x;
    } else {
      return e;
    }
  },

  timeFormatter: function (e: any) {
    if (e.currentTarget.value) {
      e.currentTarget.value = this.getFormattedTime(
        e.currentTarget.value ? e.currentTarget.value.replaceAll(":", "") : ""
      );
    }
  },

  getFormattedTime: function (e: any) {
    if (e) {
      const match = e.replace(/\D+/g, "");
      const part1 = match.length > 1 ? `${match.substring(0, 2)}` : match;
      const part2 = match.length > 2 ? `:${match.substring(2, 4)}` : "";
      var part3 = "";
      if (
        (e.length >= 4 && e.includes("p")) ||
        (e.length >= 4 && e.includes("P"))
      ) {
        var part3 = " PM";
      } else if (
        (e.length >= 4 && e.includes("a")) ||
        (e.length >= 4 && e.includes("A"))
      ) {
        var part3 = " AM";
      }
      var x = part1 + "" + part2 + "" + part3;
      return x;
    } else {
      return e;
    }
  },

  getCurrencyFormatter: function (e: any) {
    if (e || e == 0) {
      return new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(e);
    } else {
      return e;
    }
  },

  currencyFormat: function (e: any) {
    e.currentTarget.value = this.formatAmount(
      e.currentTarget.value ? e.currentTarget.value.replaceAll(",", "") : ""
    );
  },

  formatAmount: function (e: any) {
    if (e > 0) {
      var numb =
        e.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
        (e.indexOf(".") == -1 ? ".00" : "");
      return numb;
    } else {
      return "";
    }
  },

  getFormatedDateInUs(d: any) {
    return d ? moment(d).format("DD-MM-YY") : "";
  },

  getFormatedDate(d: any) {
    return d ? moment(d).format("DD/MM/YY") : "";
  },

  getFormatedDatebyYYYY(d: any) {
    return d ? moment(d).format("DD/MM/YYYY") : "";
  },

  getFormatedDateWithYear(d: any) {
    return d ? moment(d).format("YYYY-MM-DD") : "";
  },

  getFormatedDateandYear(d: any) {
    return d ? moment(d).format("YYYY-M-D") : "";
  },

  getFormatedDateAndTime(dt: any) {
    return moment(dt).format("DD/MM/YY, hh:mm A");
  },

  getFormatedDateAndTimeWithoutUTC(dt: any) {
    return moment(dt).format("DD/MM/YY, hh:mm A");
  },

  getFormatedDateForTimePicker(dt: any) {
    return moment(dt).format("YYYY-MM-DD hh:mm:ss");
  },

  getFormatedDateForSorting(dt: any) {
    if (dt) {
      return moment(dt).format("YYYY-MM-DD");
    }
  },

  getFormatedDateForDetail(dt: any) {
    if (dt) {
      return moment(dt).format("YYYY-M-D");
    }
  },

  getFormateTimeFromTime(t: any) {
    return moment(t, "hh:mm A").format("HH:mm:ss");
  },

  getFormatedTime(d: any) {
    return d ? moment(d).format("hh:mm A") : "";
  },

  getFormatedDateWithoutUTC(dt: any) {
    return moment(dt).format("YYYY-MM-DD hh:mm:ss");
  },

  getFormatedTimeWithoutUTC(d: any) {
    return d ? moment(d).format("hh:mm A") : "";
  },

  getFormatedTimeWithSecond(d: any) {
    return d ? moment(d).format("hh:mm:ss") : "";
  },

  getFormatedDays(dt: any) {
    return moment(dt).format("dddd");
  },

  removeHtml(data: string) {
    if (data) {
      return data
        .replace(/<\/?[^>]+(>|$)/g, " ")
        .replace(/\&nbsp;/g, "")
        .replaceAll("&amp;", "&")
        .replaceAll("&quot;", '"')
        .replaceAll("&#39;", "'")
        .replaceAll("&lt;", "<")
        .replaceAll("&gt;", ">")
        .trim();
    }

    return "";
  },

  isEmptyObject(data: object) {
    return Object.keys(data).length === 0;
  },

  getString(data: string, size: number) {
    if (data.length > size - 3) {
      return data.substring(0, size - 3) + "...";
    }

    return data;
  },

  validCreditCard(number: any) {
    var data = number.replaceAll("-", "");
    var isValid = "";
    var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
    var amexpRegEx = /^(?:3[47][0-9]{13})$/;
    var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
    if (visaRegEx.test(data)) {
      isValid = "VISA";
    } else if (mastercardRegEx.test(data)) {
      isValid = "MASTERCARD";
    } else if (amexpRegEx.test(data)) {
      isValid = "AMERICANEXPRESS";
    } else if (discovRegEx.test(data)) {
      isValid = "DISCOVERCARD";
    }
    return isValid;
  },

  formatCreditCard: function (e: any) {
    if (e.currentTarget.value) {
      e.currentTarget.value = this.getformatCreditCard(
        e.currentTarget.value ? e.currentTarget.value.replaceAll("-", "") : ""
      );
    }
  },

  getCompanyIcon: function (e: any) {
    if (e) {
      let logo = e.toUpperCase().split(" ");
      if (logo.length >= 2) {
        return `${logo[0].charAt(0)}${logo[1].charAt(0)}`;
      } else if (logo.length == 1) {
        return `${logo[0].charAt(0)}${logo[0].charAt(1)}}`;
      } else {
        return "";
      }
    }
  },

  getTimes(startTime: any, endTime: any, interval: number) {
    let allTimes = [];
    while (startTime < endTime) {
      allTimes.push(startTime.format("YYYY-MM-DD HH:mm:ss"));
      startTime.add(interval, "minutes");
    }

    return allTimes;
  },

  getformatCreditCard(e: any) {
    if (e) {
      const match = e.replace(/\D+/g, "");
      const part1 = match.length > 3 ? `${match.substring(0, 4)}` : match;
      const part2 = match.length > 4 ? `-${match.substring(4, 8)}` : "";
      const part3 = match.length > 8 ? `-${match.substring(8, 12)}` : "";
      const part4 = match.length > 12 ? `-${match.substring(12, 16)}` : "";
      var x = part1 + "" + part2 + "" + part3 + "" + part4;
      return x;
    } else {
      return e;
    }
  },

  getShadeColor(color: string, percent: any) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" +
            Math.min(255, Math.max(0, parseInt(color, 16) + percent)).toString(
              16
            )
          ).substr(-2)
        )
    );
  },
  capitalizeFirst(string: string) {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return "";
    }
  },
  capitalizeFirstLetter(string: any) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  },

  getFormatedModuleName(name: string) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase().replaceAll("_", " ");
  },

  getFromThen(value: any) {
    if (value) {
      var text = value.split(" ");
      var str = "";
      var isAdd = false;
      if (text.length > 0) {
        for (var i in text) {
          if (text[i] == "then") {
            isAdd = true;
          }
          if (isAdd) {
            str += `${text[i]} `;
          }
        }
      }
      return str;
    }
  },

  filter(template: string, values: any) {
    if (!values || !values.length || !template) {
      return template;
    }
    return this.toFormattedString(false, template, values);
  },

  toFormattedString(useLocale: boolean, format: any, values: any) {
    var result = "";

    for (var i = 0; ;) {
      // Find the next opening or closing brace
      var open = format.indexOf("{", i);
      var close = format.indexOf("}", i);
      if (open < 0 && close < 0) {
        // Not found: copy the end of the string and break
        result += format.slice(i);
        break;
      }
      if (close > 0 && (close < open || open < 0)) {
        if (format.charAt(close + 1) !== "}") {
          throw new Error("format stringFormatBraceMismatch");
        }

        result += format.slice(i, close + 1);
        i = close + 2;
        continue;
      }

      // Copy the string before the brace
      result += format.slice(i, open);
      i = open + 1;

      // Check for double braces (which display as one and are not arguments)
      if (format.charAt(i) === "{") {
        result += "{";
        i++;
        continue;
      }

      if (close < 0) throw new Error("format stringFormatBraceMismatch");

      // Find the closing brace

      // Get the string between the braces, and split it around the ':' (if any)
      var brace = format.substring(i, close);
      var colonIndex = brace.indexOf(":");
      var argNumber = parseInt(
        colonIndex < 0 ? brace : brace.substring(0, colonIndex),
        10
      );

      if (isNaN(argNumber)) throw new Error("format stringFormatInvalid");

      var argFormat = colonIndex < 0 ? "" : brace.substring(colonIndex + 1);

      var arg = values[argNumber];
      if (typeof arg === "undefined" || arg === null) {
        arg = "";
      }

      // If it has a toFormattedString method, call it.  Otherwise, call toString()
      if (arg.toFormattedString) {
        result += arg.toFormattedString(argFormat);
      } else if (useLocale && arg.localeFormat) {
        result += arg.localeFormat(argFormat);
      } else if (arg.format) {
        result += arg.format(argFormat);
      } else result += arg.toString();

      i = close + 1;
    }

    return result;
  },

  getRandomColor() {
    let color;
    do {
      color = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
    } while (color.toLowerCase() === '#ffffff'); // white se bachne ke liye
    return color;
  },

  convertXlsxToJson(file: any, asKeyValue: boolean = true) {
    return this.readXlsxFile(file, asKeyValue);
  },

  getXlsxSource(input: any): any {
    if (!input) return null;

    const isBlob = (v: any): v is Blob =>
      typeof Blob !== "undefined" && v instanceof Blob;

    // already parsed/read payloads
    if (input instanceof ArrayBuffer) return input;
    if (ArrayBuffer.isView(input)) return input;
    if (typeof input === "string") return input;

    // direct blob/file
    if (isBlob(input)) return input;

    // FileList
    if (typeof FileList !== "undefined" && input instanceof FileList) {
      return input.length ? input[0] : null;
    }

    // common wrappers/events (including AntD Upload + FileReader event)
    const directCandidates = [
      input?.target?.files?.[0],
      input?.currentTarget?.files?.[0],
      input?.nativeEvent?.target?.files?.[0],
      input?.dataTransfer?.files?.[0],
      input?.file,
      input?.originFileObj,
      input?.rawFile,
      input?.blob,
      input?.file?.originFileObj,
      input?.fileList?.[0]?.originFileObj,
      input?.target?.result,        // FileReader event
      input?.currentTarget?.result, // FileReader event
      input?.result,                // plain reader-like object
      input?.[0],
    ];

    for (const c of directCandidates) {
      if (!c) continue;
      if (isBlob(c) || c instanceof ArrayBuffer || ArrayBuffer.isView(c) || typeof c === "string") {
        return c;
      }
    }

    return null;
  },

  parseWorkbook(raw: any) {
    if (raw instanceof ArrayBuffer) {
      return XLSX.read(new Uint8Array(raw), { type: "array" });
    }

    if (ArrayBuffer.isView(raw)) {
      return XLSX.read(raw as any, { type: "array" });
    }

    if (typeof raw === "string") {
      // data URL base64 support
      if (raw.startsWith("data:") && raw.includes("base64,")) {
        const base64 = raw.split("base64,")[1] || "";
        return XLSX.read(base64, { type: "base64" });
      }

      // try binary first, then base64 fallback
      try {
        return XLSX.read(raw, { type: "binary" });
      } catch {
        return XLSX.read(raw, { type: "base64" });
      }
    }

    throw new TypeError("Unsupported XLSX input type.");
  },

   toSheetJson(workbook: XLSX.WorkBook, asKeyValue: boolean = true) {
    const firstSheetName = workbook.SheetNames?.[0];
    if (!firstSheetName) return [];
    const worksheet = workbook.Sheets[firstSheetName];

    // key-value mode (default)
    if (asKeyValue) {
      return XLSX.utils.sheet_to_json(worksheet, {
        defval: "",   // empty cells => ""
        raw: false,   // better formatted values
      });
    }

    // old array-of-arrays mode
    return XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  },

  readXlsxFile(fileInput: any, asKeyValue: boolean = true) {
    const source = this.getXlsxSource(fileInput);

    if (!source) {
      return Promise.reject(
        new TypeError("Invalid file input. Please pass a File/Blob, FileReader result, or input change event.")
      );
    }

    if (!(source instanceof Blob)) {
      try {
        const workbook = this.parseWorkbook(source);
        return Promise.resolve(this.toSheetJson(workbook, asKeyValue));
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        try {
          const result = event.target?.result;
          if (!(result instanceof ArrayBuffer)) {
            reject(new TypeError("Failed to read file as ArrayBuffer."));
            return;
          }

          const workbook = this.parseWorkbook(result);
          resolve(this.toSheetJson(workbook, asKeyValue));
        } catch (err) {
          reject(err);
        }
      };

      reader.onerror = () => reject(reader.error);
      reader.readAsArrayBuffer(source);
    });
  },
};

export default HelperService;
